import React, { PureComponent } from 'react'
import { Button, Modal, Form } from 'react-bootstrap'
import { Field, reduxForm } from 'redux-form'
import InputDatePicker from '../../../components/commons/form/InputDatePicker'
import { handleKeyDown } from '../../../util/utils'

class SetAvailabilityDateModal extends PureComponent {
  constructor () {
    super()
    this.state = {
      invalidDate: true
    }
  }

  submitAvailabilityDate (values) {
    this.props.saveServicesAvailabilityDate(values.availabilityDate)
  }

  getSnapshotBeforeUpdate () {
    return null
  }

  componentDidUpdate (prevProps) {
    if (prevProps.showModal !== this.props.showModal && this.props.showModal) {
      this.props.reset()
    }
  }

  handleDateChange (value) {
    this.setState({ invalidDate: !value })
  }

  componentWillUnmount () {
    this.props.reset()
  }

  render () {
    const {
      t, handleSubmit, showModal, closeModal
    } = this.props
    const tKey = 'SEARCH.CATEGORIES.PAP_SERVICES_MANAGER.'

    return (
      <Modal id='SetAvailabilityDateModal' show={showModal}
        backdrop="static"
        keyboard={false}
        className="_nf"
        onHide={closeModal}>
        <Form autoComplete="off" onSubmit={handleSubmit(this.submitAvailabilityDate.bind(this))} onKeyDown={(e) => handleKeyDown(e)}>
          <Modal.Header closeButton={false} className="availabilityDateHeaderModal">
            <Modal.Title>{t(`${tKey}AVAILABILITY_DATE`)}</Modal.Title>
          </Modal.Header>
          <Modal.Body className="availabilityDateBodyModal">
            <div className='fieldsContainer'>
              <Field
                component={InputDatePicker}
                colWidth={100} // 25, 33, 50, 75, 100 default=25
                className="availabilityDateOnModal"
                colSm={12}
                id='availabilityDate'
                name= 'availabilityDate'
                placeholder={t(`${tKey}DATE`)}
                controlLabel={t(`${tKey}DATE`)}
                onChange={(value) => this.handleDateChange(value)}
                disabled={this.props.disabledDate}
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div className='flexInLine al-C'>
              <Button
                id = "acceptAndCloseModal"
                className="_Btn accept"
                type="submit"
                bsSize = "sm"
                disabled = {this.props.pristine || this.state.invalidDate}>
                {t(`${tKey}APPLY`)}
              </Button>
              <Button
                id="closeModal"
                className="_Btn cancel"
                bsSize = "sm"
                onClick = {closeModal}>
                {t(`${tKey}CANCEL`)}
              </Button>
            </div>

          </Modal.Footer>
        </Form>
      </Modal>

    )
  }
}
export default reduxForm({
  form: 'SetAvailabilityDateModal'
})(SetAvailabilityDateModal)
